export default __webpack_public_path__ + "static/media/horse-head.4901a7b7.png";